import { getShipDeadline, getShippingWindowState, parseWindowStart } from 'utils/shippingWindow';

export interface ReceivingShipWindow {
  remainingMs: number;
  isExpired: boolean;
  /** Percentage of the window REMAINING (100 at the start, 0 at the deadline). */
  percentage: number;
}

/**
 * The sender's shipping window as the receiver sees it.
 *
 * Anchored on shipWindowStart (openedAt ?? initiatedAt, computed by the
 * backend), never on initiated: a sequenced second leg is created at accept
 * but cannot ship until it opens, so measuring from initiated charged its
 * sender for the whole first leg and showed it overdue the moment it opened.
 *
 * Null when there is no window: shipWindowStart is null while the leg is
 * awaiting funding and on removed-item rows.
 */
export const getReceivingShipWindow = (
  shipWindowStart: string | null | undefined,
  nowMs: number
): ReceivingShipWindow | null => {
  if (!shipWindowStart) return null;
  const startMs = parseWindowStart(shipWindowStart);
  if (startMs == null || Number.isNaN(startMs)) return null;
  const { isExpired, percentage } = getShippingWindowState(startMs, nowMs);
  return { remainingMs: getShipDeadline(startMs) - nowMs, isExpired, percentage };
};

/** "Time to ship" line for a preparing trade that has a window. */
export const formatTimeToShip = (window: ReceivingShipWindow | null): string => {
  if (!window) return 'Time to ship: —';
  if (window.isExpired) return 'Overdue';
  const hoursRemaining = window.remainingMs / (60 * 60 * 1000);
  if (hoursRemaining >= 24) {
    const days = Math.ceil(hoursRemaining / 24);
    return `Time to ship: ${days} day${days > 1 ? 's' : ''}`;
  }
  const hours = Math.ceil(hoursRemaining);
  return `Time to ship: ${hours} hour${hours > 1 ? 's' : ''}`;
};
